import React, { useState } from "react";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

const PasswordTextField = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  return (<TextField
    variant="filled"
    autoFocus
    margin="dense"
    InputProps={props.InputProps}
    InputLabelProps={props.InputLabelProps}
    label={props.label}
    fullWidth
    type={showPassword ? "text" : "password"}
    value={props.value}
    onChange={props.onChange}
    error={props.error}
    helperText={props.helperText}
    InputProps={{ // <-- This is where the toggle button is added.
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            aria-label="toggle password visibility"
            onClick={handleClickShowPassword}
            onMouseDown={handleMouseDownPassword}
          >
            {showPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </InputAdornment>
      )
    }}
  />);

}

export default PasswordTextField;